import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { CampsModel } from './CampsModel';
import { SearchModel } from '../MasterData/SearchModel';
@Injectable({
  providedIn: 'root'
})
export class CampsService {

 
  
  constructor(private http: HttpClient ) { }
  baseUrl = environment.baseApiUrl;
  token = localStorage.getItem("token");
  httpOptions = {
   headers: new HttpHeaders({
      "Authorization": "Bearer " + this.token,
      "Content-Type": "application/json"
   })
 };

 getAll(): Observable<any> {
   
  return this.http
    .get<any>(`${this.baseUrl}Camping/GetAll`,this.httpOptions)
    .pipe(catchError((error: any) => throwError(error => error)));
}

GetAllByCountryId(countryId:number): Observable<any> {
   
  return this.http
    .get<any>(`${this.baseUrl}Camping/GetAllByCountryId/${countryId}`,this.httpOptions)
    .pipe(catchError((error: any) => throwError(error => error)));
}
getById(Id:number): Observable<any> {

  return this.http
    .get<any>(`${this.baseUrl}Camping/GetById/${Id}`,this.httpOptions)
    .pipe(catchError((error: any) => throwError(error => error)));
}
insert(payload: CampsModel): Observable<any> {
  
  return this.http
    .post<any>(`${this.baseUrl}Camping/Insert`, payload,this.httpOptions)
    .pipe(catchError((error: any) => throwError(error => error)));
}
GetAllByDate(payload: SearchModel): Observable<any> {
  
  return this.http
    .post<any>(`${this.baseUrl}Camping/GetAllByDate`, payload,this.httpOptions)
    .pipe(catchError((error: any) => throwError(error => error)));
}
update(payload: CampsModel): Observable<any> {
  return this.http
    .post<any>(`${this.baseUrl}Camping/Update`, payload,this.httpOptions)
    .pipe(catchError((error: any) => throwError(error => error)));
}

delete(Id:number): Observable<any> {
  return this.http
    .get<any>(`${this.baseUrl}Camping/Delete/${Id}`,this.httpOptions)
    .pipe(catchError((error: any) => throwError(error => error)));
}


}
